/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { NatsCaller } from "../../NatsCaller";
import type {
  CreateSyncSessionRequest,
  CreateSyncSessionResponse,
  EmptyResponse,
  GetALMIssuesRequest,
  GetALMIssuesResponse,
  GetLinkTypeResponse,
  GetLinkTypesResponse,
  GetSessionInfoResponse,
  GetStatusResponse,
  UpdateLinkTypeRequest,
} from "./models";
import {
  createSyncSessionResponseSchema,
  emptyResponseSchema,
  getALMIssuesResponseSchema,
  getLinkTypeResponseSchema,
  getLinkTypesResponseSchema,
  getSessionInfoResponseSchema,
  getStatusResponseSchema,
} from "./schemas";

export class NatsAlmsyncCommonClient {
  constructor(private caller: NatsCaller) {}

  async deleteCompany(): Promise<EmptyResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.almsync.v1.companies.delete";
    return await this.caller.request(subject, "deleteCompany", {}, emptyResponseSchema);
  }

  async createSession(payload: CreateSyncSessionRequest): Promise<CreateSyncSessionResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.create";
    return await this.caller.request(
      subject,
      "createSession",
      payload,
      createSyncSessionResponseSchema,
    );
  }

  async getSessionInfo(session_id: string): Promise<GetSessionInfoResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getSessionInfo", {}, getSessionInfoResponseSchema);
  }

  async removeSyncSession(session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.delete".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "removeSyncSession", {}, emptyResponseSchema);
  }

  async getStatus(session_id: string): Promise<GetStatusResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.sync.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getStatus", {}, getStatusResponseSchema);
  }

  async stop(session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.sync.stop".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "stop", {}, emptyResponseSchema);
  }

  async getLinkTypes(session_id: string): Promise<GetLinkTypesResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.link_types.get".replace(
        "${session_id}",
        session_id,
      );
    return await this.caller.request(subject, "getLinkTypes", {}, getLinkTypesResponseSchema);
  }

  async getLinkType(session_id: string, link_type_id: string): Promise<GetLinkTypeResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.link_types.${link_type_id}.get"
        .replace("${session_id}", session_id)
        .replace("${link_type_id}", link_type_id);
    return await this.caller.request(subject, "getLinkType", {}, getLinkTypeResponseSchema);
  }

  async updateLinkType(
    payload: UpdateLinkTypeRequest,
    session_id: string,
    link_type_id: string,
  ): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.link_types.${link_type_id}.update"
        .replace("${session_id}", session_id)
        .replace("${link_type_id}", link_type_id);
    return await this.caller.request(subject, "updateLinkType", payload, emptyResponseSchema);
  }

  async deleteLinkType(session_id: string, link_type_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.almsync.v1.sessions.${session_id}.link_types.${link_type_id}.delete"
        .replace("${session_id}", session_id)
        .replace("${link_type_id}", link_type_id);
    return await this.caller.request(subject, "deleteLinkType", {}, emptyResponseSchema);
  }

  async getAlmIssues(payload: GetALMIssuesRequest): Promise<GetALMIssuesResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.almsync.v1.alm_issues.get";
    return await this.caller.request(subject, "getAlmIssues", payload, getALMIssuesResponseSchema);
  }
}
